import "./uikit.almost-flat.css";
import "./kendo.css";
import "./app.css";

import React from "react";
import { useState, useEffect } from "react";
import { authGuest, setToken, isAuthenticated, getToken, isLogin, getUser, setDelToken, checkAdmToken } from "./service/authService";
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import axios from "axios";
import { getCodes } from "./service/codeService";
import { getRgns, getDongs } from "./service/areaService";
import { BrowserRouter, useLocation } from "react-router-dom";
import { BrowserView, MobileView } from 'react-device-detect'
import Contents from "./contents";
import { getMessage } from "./com/messageUtil";
import Login from "./components/login/login";
import Error from "./components/error";

// mobile
import LoginMobile from "./components/mobile/login/login_mobile";
import ContentsMobile from "./components/mobile/contents_mobile";

function App() {

    // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("확인을 눌러주세요.");
  
  const closeCompleteDialog = () => {
    setDelToken();
    window.location.href = "/";
    setCompleteDialogVisible(false);
  }

  // console.log("getToken = ", getToken());
  const conn = axios.create({
    baseURL: `${process.env.REACT_APP_REST_API_VERSION}`,
    config: {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
  });
  conn.interceptors.request.use(
    config => {
      const token = getToken();
      if (token) config.headers.common["X-AUTH-TOKEN"] = token;
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  conn.interceptors.response.use(
    response => {
      // // 대상자 토큰 확인
      // if (getUser() && getUser().userTypeCode === 2001 && response.config.url !== "/login/adm/checkToken") {
      //   checkAdmToken(conn)
      //     .then((response) => {
      //       console.log("interceptors response then response = ", response);
      //     })
      //     .catch((e) => {
      //       console.log("interceptors response catch e = ", e);
      //       if (e.errCode === "F013") {
      //         setDialogMessage("다른 기기에 연결되어 현재 서버 연결이 종료되었습니다.");
      //         setCompleteDialogVisible(true);
      //       }
      //     });
      // }
      // console.log('response url ', response.config.url, response);
      const result = response.data;
      if (result.code == "T000" || result.code == "T001") {
        authGuest(conn).then(result => {
          // console.log("토큰삭제로 재발급");
          setToken(result.token);
          window.location.href = "/";
        });
      } else if (result.code == "T002") {
        window.location.href = "/";
        // alert("로그인 후 이용가능합니다.");
      }
      if (result.status != 200) {
        throw { errCode: result.code };
      }
      return result.data;
    },
    async function (error) {
      console.log("error error", error);
      setDelToken();
      setIsError(true);
      // alert("통신중 오류가 발생하였습니다. 네트워크 연결 상태를 확인하십시오.");
      return Promise.reject(error);
    },
  );

  const [state, setState] = useState({
    codeList: [],
    rgnList: [],
    dongList: [],
  });

  const setDefaultData = () => {
    let errList = [];
    Promise.all([getCodes(conn), getRgns(conn), getDongs(conn, getUser().rgnCode)]) //
      .then(results => {
        if (errList.length > 0) {
          const set = new Set(errList);
          const uniqueErrList = [...set];
        }
        setState(state => {
          const item = { ...state };
          item.codeList = results[0];
          item.rgnList = results[1];
          results[2].sort(function (a, b) {
            // 문자열 정렬
            if (a.dongTermSimple < b.dongTermSimple) {
              return -1;
            } else if (a.dongTermSimple > b.dongTermSimple) {
              return 1;
            } else {
              return 0;
            }
          });
          item.dongList = results[2];
          return item;
        });
      })
      .catch(err => {
        // alert(getMessage(err.errCode));
        console.log("initial data load Fail", err);
      });
  };

  const [loginStatus, setLoginStatus] = useState(isLogin() ? true : false);
  const setUpdateLoginStatus = status => {
    setLoginStatus(status);
  };

  useEffect(() => {
    if (isAuthenticated()) {
      // 로그인 여부 확인
      setDefaultData();
      if (isLogin()) {
        setUpdateLoginStatus(true);
      }
    } else {
      authGuest(conn) // 게스트 로그인 처리
        .then(result => {
          setToken(result.token);
          setDefaultData();
        });
    }
    //브라우저 종료 시 localStorage 삭제
    // window.addEventListener("beforeunload", function (event) {
    //   localStorage.removeItem("cwtk");
    //   setDelToken();
    // });
  }, []);

  // useEffect(() => {
    // setDefaultData();
  // }, [getUser().rgnCode]);

  // useEffect(() => {
    // if (getUser().userTypeCode === 2001) {
    //   alert("권한이 없습니다.");
    //   setDelToken();
    //   authGuest(conn).then(result => {
    //     setToken(result.token);
    //     setUpdateLoginStatus(false);
    //   });
    // }
  // }, [getUser()]);

  const { codeList, rgnList, dongList } = state;
  const [isError, setIsError] = useState(false);
  const setError = is => setIsError(is);

  return isError ? (
    <Error/>
    ): (
    <BrowserRouter>
      {loginStatus ? (
        //codeList.length > 0 && rgnList.length > 0 &&  dongList.length > 0
        //&& loginStatus ?
        <>
          <BrowserView>
            <Contents
              conn={conn}
              codeList={codeList}
              rgnList={rgnList}
              dongList={dongList}
              loginStatus={loginStatus}
              setUpdateLoginStatus={setUpdateLoginStatus}
            />
          </BrowserView>
          <MobileView>
            <ContentsMobile
              conn={conn}
              codeList={codeList}
              rgnList={rgnList}
              dongList={dongList}
              loginStatus={loginStatus}
              setUpdateLoginStatus={setUpdateLoginStatus}
            />
          </MobileView>
        </>
        ) : (
        <>
          <BrowserView>
            <Login conn={conn} setUpdateLoginStatus={setUpdateLoginStatus} loginStatus={loginStatus} />
          </BrowserView>
          <MobileView>
            <LoginMobile conn={conn} setUpdateLoginStatus={setUpdateLoginStatus} loginStatus={loginStatus} />
          </MobileView>
        </>
        )
      }      
      {completeDialogVisible && (
        <Dialog
          className="completeDialog"
          width={"90vw"}
          height={"40vw"}
          closeIcon={false}
        >
          <p>
            {dialogMessage}
            <br></br>
            <button onClick={closeCompleteDialog}>확인</button>
          </p>
        </Dialog>
      )}
    </BrowserRouter>
  );
}

export default App;
